import { BaseClient } from './BaseClient'

export class BillingApi extends BaseClient {
  rates = {
    get: this.createRequest({
      url: '/api/public/billing/products',
      method: 'get',
    }),
  }
  cancelSubscription = this.createRequest({
    url: '/api/billing/subscription/disable',
    method: 'post',
  })
}
